import DOMPurify from "dompurify";

interface HtmlContentProps {
  content: string;
  className?: string;
  style?: React.CSSProperties;
  as?: keyof JSX.IntrinsicElements;
}

const HtmlContent = ({
  content,
  className,
  style,
  as: Component = "div",
}: HtmlContentProps) => {
  const sanitizedContent = DOMPurify.sanitize(content);

  return (
    <Component
      className={className}
      style={style}
      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
    />
  );
};

export default HtmlContent;

